/* @flow */

export const AUTHENTICATION_REQUIRED_MODAL: 'AUTHENTICATION_REQUIRED_MODAL' = 'AUTHENTICATION_REQUIRED_MODAL';
export const AVENUE_MODAL: 'AVENUE_MODAL' = 'AVENUE_MODAL';
export const CARD_MODAL: 'CARD_MODAL' = 'CARD_MODAL';
export const CONFIRMATION_MODAL: 'CONFIRMATION_MODAL' = 'CONFIRMATION_MODAL';
export const EULA_MODAL: 'EULA_MODAL' = 'EULA_MODAL';
export const EXTERNAL_CONTENT_MODAL: 'EXTERNAL_CONTENT_MODAL' = 'EXTERNAL_CONTENT_MODAL';
export const GAME_PROFILE_SELECT_MODAL: 'GAME_PROFILE_SELECT_MODAL' = 'GAME_PROFILE_SELECT_MODAL';
export const KEYBOARD_SHORTCUTS_MODAL: 'KEYBOARD_SHORTCUTS_MODAL' = 'KEYBOARD_SHORTCUTS_MODAL';
export const LEGAL_NOTICE_MODAL: 'LEGAL_NOTICE_MODAL' = 'LEGAL_NOTICE_MODAL';
export const MESSAGE_MODAL: 'MESSAGE_MODAL' = 'MESSAGE_MODAL';
export const NEW_VERSION_MODAL: 'NEW_VERSION_MODAL' = 'NEW_VERSION_MODAL';
export const NPVR_HELP_MODAL: 'NPVR_HELP_MODAL' = 'NPVR_HELP_MODAL';
export const NPVR_MODAL: 'NPVR_MODAL' = 'NPVR_MODAL';
export const PARENTAL_CONTROL_MODAL: 'PARENTAL_CONTROL_MODAL' = 'PARENTAL_CONTROL_MODAL';
export const PIN_MODAL: 'PIN_MODAL' = 'PIN_MODAL';
export const PRESENCE_CHECK_MODAL: 'PRESENCE_CHECK_MODAL' = 'PRESENCE_CHECK_MODAL';
export const PROFILE_AVATAR_SELECT_MODAL: 'PROFILE_AVATAR_SELECT_MODAL' = 'PROFILE_AVATAR_SELECT_MODAL';
export const PROFILE_EDITOR_MODAL: 'PROFILE_EDITOR_MODAL' = 'PROFILE_EDITOR_MODAL';
export const PROFILE_SPLASHSCREEN_MODAL: 'PROFILE_SPLASHSCREEN' = 'PROFILE_SPLASHSCREEN';
export const PROFILES_MODAL: 'PROFILES_MODAL' = 'PROFILES_MODAL';
export const SETTINGS_MODAL: 'SETTINGS_MODAL' = 'SETTINGS_MODAL';
export const VOD_PURCHASE_MODAL: 'VOD_PURCHASE_MODAL' = 'VOD_PURCHASE_MODAL';

export type MODAL_TYPE =
  | typeof AUTHENTICATION_REQUIRED_MODAL
  | typeof AVENUE_MODAL
  | typeof CARD_MODAL
  | typeof CONFIRMATION_MODAL
  | typeof EULA_MODAL
  | typeof EXTERNAL_CONTENT_MODAL
  | typeof GAME_PROFILE_SELECT_MODAL
  | typeof KEYBOARD_SHORTCUTS_MODAL
  | typeof LEGAL_NOTICE_MODAL
  | typeof MESSAGE_MODAL
  | typeof NEW_VERSION_MODAL
  | typeof NPVR_HELP_MODAL
  | typeof NPVR_MODAL
  | typeof PARENTAL_CONTROL_MODAL
  | typeof PIN_MODAL
  | typeof PRESENCE_CHECK_MODAL
  | typeof PROFILE_AVATAR_SELECT_MODAL
  | typeof PROFILE_EDITOR_MODAL
  | typeof PROFILE_SPLASHSCREEN_MODAL
  | typeof PROFILES_MODAL
  | typeof SETTINGS_MODAL
  | typeof VOD_PURCHASE_MODAL;
